import { Component, computed, inject, input } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_LOADER } from '@progress/kendo-angular-indicators';
import { KENDO_STACKLAYOUT } from '@progress/kendo-angular-layout';
import { AhfcIdentityErrorCodes, ApiException, isUnityIdentityProblem, PublicUsersClient } from '@unity/clients';
import { OutsideContainerComponent } from '@unity/layouts/outside-container/outside-container.component';
import { LayoutService } from '@unity/services/layout.service';

@Component({
  selector: 'unity-login-confirm-user-page',
  standalone: true,
  imports: [KENDO_STACKLAYOUT, KENDO_LOADER, KENDO_BUTTON, RouterLink, OutsideContainerComponent],
  templateUrl: './login-confirm-user-page.component.html',
  styleUrl: './login-confirm-user-page.component.scss',
})
export class LoginConfirmUserPageComponent {
  private readonly publicUsersClient = inject(PublicUsersClient);
  private readonly layoutService = inject(LayoutService);

  protected detailCardGridLayoutGap = this.layoutService.detailCardGridLayoutGap;

  public readonly $userId = input.required<string>({ alias: 'userId' });
  public readonly $token = input.required<string>({ alias: 'token' });

  protected confirmUserResource = rxResource({
    params: () => {
      const userId = this.$userId();
      const token = this.$token();
      return userId && token ? { userId, token } : undefined;
    },
    stream: ({ params: { userId, token } }) => this.publicUsersClient.confirmOne(userId, { token }),
  });

  protected readonly $confirmUser = computed(() => {
    if (this.confirmUserResource.hasValue()) {
      return this.confirmUserResource.value();
    }
    return null;
  });

  protected $error = this.confirmUserResource.error;
  protected readonly $invalidToken = computed(() => {
    const error = this.confirmUserResource.error();
    if (
      error &&
      ApiException.isApiException(error) &&
      isUnityIdentityProblem(error.result) &&
      error.result.error_code == AhfcIdentityErrorCodes.UserInvalidToken
    ) {
      return true;
    }
    return false;
  });
}
